
import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import {unmountComponentAtNode} from 'react-dom';
import Configdata from './Defaultdata';
import Search from './Search';
import Home from './Home';

import Profile from './Profile';

import Posting from './Posting';

import Searchcriteria from './Searchcriteria';

import Register from './Register';

import userp from './imgs/profileuser.png';
import sineup from './imgs/sign-up-icon.png';
import search from './imgs/search.png';

import earthback from './imgs/sky.jpg';

import stepup from './imgs/stepup.jpeg';

import postingimg from './imgs/posting.png';
import { getmessage,wrongmsg,unauthomsg,hidediv } from './Dynamictable';
import {clearmain,clearprofile} from './clearmem';
import {isvaliduser} from './validation';

class Header extends Component {
	constructor(props: any) {
   	super(props);
	this.state.toggleprofile = false;
	this.state.togglecriteria = false;
	this.state.togglesinup = false;
	this.state.toggleposting = false;


    	this.toggeluserprofile = this.toggeluserprofile.bind(this);
	this.loadsearch = this.loadsearch.bind(this);
	this.loadregister = this.loadregister.bind(this);
	this.loadPosting = this.loadPosting.bind(this);

	
  	}
	state = {
        name: "SIIKAA",
        toggleprofile: false,
	togglecriteria: false,
	togglesinup: false,
        toggleposting: false
    	};

	toggeluserprofile(){
		if(!isvaliduser()){
		  getmessage('First time signup -> authoriz login -> Profile','Next time ->  authoriz login -> Profile');
		}
		else{
		const element = <Profile />
		const chkpvisible = this.state.toggleprofile == false ? true: false;
		if(chkpvisible) clearprofile();
                const Pdiv = document.getElementById('profilediv') as HTMLElement;
		//ReactDOM.render(element,Pdiv);

		
		this.setState({ toggleprofile: chkpvisible });
		if(chkpvisible){
		
		ReactDOM.render(element,Pdiv);
		Pdiv.style.display = 'block';
		//clearmain();
		}
		else
		{
		Pdiv.style.display = 'none';
		}

		this.setState({ togglecriteria: false });
		this.setState({ togglesinup: false });
		
		const homemain = document.getElementById('container') as HTMLElement;
		homemain.style.display = 'none';
		
	    }
		  this.hidechat();	

	};
        hidechat(){
	    hidediv('txtchatgtp');
     	    hidediv('processiconchat');
     	    hidediv('chatgptmsgshow');
	};
	loadsearch(){
		
		const elesrch = <Searchcriteria />
                const Pdivc = document.getElementById('profilediv') as HTMLElement;
		const homemain = document.getElementById('container') as HTMLElement;
		//const serarchoptiondv = document.getElementById('selectprotypediv') as HTMLElement;
		const chkpvisible = this.state.togglecriteria == false ? true: false;		
		//ReactDOM.render(elesrch,Pdivc);
	
		this.setState({ togglecriteria: chkpvisible });
		if(chkpvisible){
		clearprofile();
		ReactDOM.render(elesrch,Pdivc);
		Pdivc.style.display = 'block';
		homemain.style.display = 'none';
		//serarchoptiondv.style.display ='block';
		}
		else{
		Pdivc.style.display = 'none';
		//homemain.style.display = 'block';
		}
		
		this.setState({ toggleprofile: false });
		
		this.setState({ togglesinup: false });
		
			  this.hidechat();	



	};

	loadregister(){
		
	       
		const elesrch = <Register />
		const Pdcivr = document.getElementById('container') as HTMLElement;

                const Pdivr = document.getElementById('profilediv') as HTMLElement;
		//ReactDOM.render(elesrch,Pdivr);
		

		const chkpvisible = this.state.togglesinup == false ? true: false;
		this.setState({ togglesinup: chkpvisible });
		if(chkpvisible){
		ReactDOM.render(elesrch,Pdivr);
		Pdivr.style.display = 'block';
		clearmain();
		}
		else{
		Pdivr.style.display = 'none';
		
		}
		
		this.setState({ toggleprofile: false });
		this.setState({ togglecriteria: false });
		//this.setState({ togglesinup: false });
		Pdcivr.style.display = 'none';
			  this.hidechat();	


		
	};

	loadPosting(){
	  if(!isvaliduser()){
		  getmessage('First time signup -> authoriz login -> post','Next time  authoriz login -> post');
		}
		else{

		const logtype = localStorage.getItem("ltype");
		
		if(logtype == 'authorized'){
			const chkpvisible = this.state.toggleposting == false ? true: false;
			this.setState({ toggleposting: chkpvisible });
			const Pdivr = document.getElementById('container') as HTMLElement;
			const Pdiv = document.getElementById('profilediv') as HTMLElement;

			
			if(chkpvisible){
			const post = <Posting />
			//alert(post);
           		ReactDOM.render(post,Pdivr);
			Pdivr.style.display = 'block';
			Pdiv.style.display = 'none';
			}
			else{
			Pdivr.style.display = 'none';
			this.setState({ toggleposting: false });
			
			}
			
		}
		else
		{
			unauthomsg();
		}
             

	}
		  this.hidechat();	
	};



	componentDidMount() {
        //debugger;
     	//this.toggeluserprofile();
     
    	}
       
	
	render() {
		return (
		<form>
		<div className="per100">

			<div id="profilediv" className="sidebar-profile">
   			   <div>
				
				 Profile
			    </div>

			</div>

			<div className="headertopmenu-comp">

				<div className="headertop-submenu-logo" style={{border:'none'}}>
				
				<img src={stepup} className="per100" />
				</div>
				<div className="headertop-submenu-cnt" style={{border:'none'}}>
				Citi Home				
				</div>

			</div>


			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#"  onClick={this.toggeluserprofile} title="Profile"><img src={userp} className="per100" /></a>
				</div>

			</div>
			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#"  onClick={this.loadregister} title="Register"><img src={sineup} className="per100" /></a>
				</div>

			</div>
			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#"  onClick={this.loadsearch} title="Search"><img src={search} className="per100" /></a>
				</div>

			</div>

			<div className="headertopmenu">

				<div className="headertop-submenu" style={{border:'none'}}>
				
				<a  href="#" onClick={this.loadPosting} title="Post"><img src={postingimg} className="per100" /></a>

				</div>

			</div>


		</div>
		</form>
		);
	}

	
}

export default Header;
